import axiosInstance from "@/axios/axiosInstance";
import { LoginCredentials, LoginWithTokenPayload } from "@/interface/auth.types";

export const loginUser = async (data: LoginCredentials) => {
  const payload = {
    email: data.username,
    password: data.password,
  };
  const response = await axiosInstance.post(`/login`, payload);
  return response?.data;
};

export const loginWithToken = async (data: LoginWithTokenPayload) => {
  const response = await axiosInstance.post(`/login-with-token`, data);
  return response?.data;
};
